module.exports = __webpack_public_path__ + "assets/img/4_40_big.0c8746e5.jpg";